import { useState } from 'react';
import { api, ApiError } from '../lib/api.ts';
import { useT } from '../i18n/index.tsx';

/**
 * The front door (task 18): the demo code, and nothing else, until it is
 * right. The server remembers it for this browser, so it is asked for once
 * rather than with every room.
 *
 * Only the creator ever sees this. A guest opens an invitation link, and the
 * invitation is their way in.
 */
export function Login({ onDone }: { onDone: () => void }) {
  const t = useT();
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      await api.login(code);
      onDone();
    } catch (err) {
      setError(
        err instanceof ApiError && err.code === 'bad_access_code'
          ? t.login.wrong
          : err instanceof ApiError
            ? err.message
            : t.login.failed,
      );
      setBusy(false);
    }
  }

  return (
    <form
      className="card"
      onSubmit={(e) => {
        e.preventDefault();
        if (code && !busy) void submit();
      }}
    >
      <h1>{t.login.title}</h1>
      <p className="lede">{t.login.lede}</p>

      {error && <div className="notice bad">{error}</div>}

      <div className="field">
        <label htmlFor="code">{t.home.accessCode}</label>
        <input
          id="code"
          type="password"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoComplete="current-password"
          autoFocus
        />
      </div>

      <div className="actions">
        <button type="submit" className="primary" disabled={busy || code === ''}>
          {busy ? t.login.checking : t.login.submit}
        </button>
      </div>
    </form>
  );
}
